import React, { useRef } from 'react';
import Button from '@material-ui/core/Button';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import useDropdown from 'common/components/use-dropdown/useDropdown';

const DropdownNavItem: React.FC<IDropdownNavItemProps> = ({
  label,
  NavItemComponent,
  isLink,
  RouteLink,
  route,
  dropdownData,
}) => {
  const { anchorEl, handleClick, handleClose } = useDropdown();
  const closeTimeoutRef = useRef<number | null>(null);

  /**
   * Hides the dropdown after a small delay. This is so the user gets a chance to
   * move the cursor into the dropdown menu. Which is responsible for cancelling
   * this timeout id.
   */
  const closeDropdownWithDelay = () => {
    closeTimeoutRef.current = window.setTimeout(handleClose, 100);
  };

  const handleDropdownMouseEnter = () => {
    // The cursor left the dropdown button and entered the dropdown menu.
    // So we cancel the close call we made on mouse leave from the button.
    if (closeTimeoutRef.current)
      clearTimeout(closeTimeoutRef.current);
  };

  return (
    <>
      <Button
        onMouseEnter={handleClick}
        onMouseLeave={closeDropdownWithDelay}
        onClick={handleClick}
        variant="text"
        color="primary"
        endIcon={
          anchorEl !== null ? (
            <ArrowDropUpIcon />
          ) : (
            <ArrowDropDownIcon />
          )
        }
      >
        {isLink ? (
          <RouteLink to={route} style={{ color: '#44924C' }}>
            {label}
          </RouteLink>
        ) : (
          label
        )}
      </Button>
      <NavItemComponent
        anchorEl={anchorEl}
        handleClose={handleClose}
        MenuListProps={{
          onMouseEnter: handleDropdownMouseEnter,
          onMouseLeave: handleClose,
        }}
        dropdownData={dropdownData}
      />
    </>
  );
};

export default DropdownNavItem;
